import { Survey, SurveyMetadataForm } from '../models';

export function surveyToMetadataForm(survey: Survey): SurveyMetadataForm {
  return {
    title: survey.title,
    selectedTemplate: survey.templateId ?? null,
    selectedCountries: [survey.countryCode],
    selectedLanguages: [survey.languageShortCode],
    completes: survey.completesRequired,
    loi: survey.expectedLoi,
    incidence: survey.expectedIr,
    fieldTime: survey.fieldTime,
    clickBalancing: !!survey.clickBalancing,
  };
}
